import AddActionIcon from 'icons/AddActionIcon'
import CategoriesIcon from 'icons/iam/CategoriesIcon'
import ColoredWhitespace from 'components/core-ui/ColoredWhitespaces/ColoredWhitespace'
import { People } from '@mui/icons-material'
import * as Yup from 'yup'

export const toolbarActions = ({
  canCreate,
  navigate,
  openModal,
  isUndefinedJobs = false
}) => {
  const toolbar = []
  const createButton = {
    label: 'Add new job',
    icon: <AddActionIcon />,
    onClick: () => openModal()
  }

  const goToJobCategoriesButton = {
    label: 'Job Categories',
    icon: <CategoriesIcon width={18} strokeColor={'#0970E6'} />,
    onClick: () => navigate('/iam/jobCategories')
  }
  toolbar.push(goToJobCategoriesButton)

  const goToUndefinedJobsButton = {
    label: isUndefinedJobs ? 'Jobs' : 'Unlisted Jobs',
    icon: <People />,
    onClick: () => navigate(isUndefinedJobs ? '/iam/jobManagement' : '/iam/jobManagement?undefinedJobs=true')
  }
  toolbar.push(goToUndefinedJobsButton)

  if (canCreate) {
    toolbar.push(createButton)
  }
  return toolbar
}

export const columns = [
  {
    field: 'jobTitle',
    title: 'Job Name',
    align: 'left',
    render: rowData => <ColoredWhitespace text={rowData.jobTitle} />
  },
  {
    field: 'jobCategory',
    title: 'Job Category',
    align: 'left',
    render: rowData => rowData.jobCategory?.name || rowData.jobCategory?.id
  },
  {
    field: 'jobDetails',
    title: 'Employee Category',
    align: 'left',
    render: rowData => rowData.jobDetails?.name
  },
  {
    field: 'active',
    title: 'Status',
    align: 'left',
    render: rowData => rowData.active ? 'Active' : 'Inactive'
  }
]

export const initialFilter = {
  page: 0,
  filters: [],
  rowsPerPage: 10,
  order: undefined,
  orderBy: undefined,
  tableFilters: [],
  searchText: ''
}

export const jobValidationSchema = Yup.object().shape({
  jobTitle: Yup.string().required('Job Title is required'),
  jobDetails: Yup.string().required('Obs are required'),
  jobCategory: Yup.number().required('Job Category is required')
})

export const updateFilter = (filters: any[], name: string, value: any) => {
  const index = filters.findIndex(filter => filter.name === name)
  if (index !== -1) {
      filters[index].value = value
  } else {
      filters.push({ name, value })
  }
}
